import React from "react";

const DriverInfoInput = React.forwardRef(function DriverInfoInput(
  {
    name,
    id,
    placeholder,
    value,
    onChange,
    type = "text",
    autoComplete,
    className,
    error,
    disabled,
  },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      value={value || ""}
      onChange={onChange}
      id={id}
      name={name}
      placeholder={placeholder}
      className={`form-control text-center ${className} ${
        error ? "error" : ""
      }`}
      autoComplete={autoComplete}
      disabled={disabled}
    />
  );
});

export default DriverInfoInput;

export function LabeledDriverInfoInput({
  type = "text",
  name,
  id,
  label,
  labelComp,
  value,
  onChange,
  validationObject,
  placeholder,
  autoComplete,
  disabled,
  className,
  wrapperStyle,
  inputRef,
}) {
  const hasError = (!validationObject?.isValid) || false
  return (
    <div style={wrapperStyle}>
      <label className='text-center' htmlFor={id}>{labelComp || label}</label>
      <DriverInfoInput
        ref={inputRef}
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        id={id}
        name={name}
        error={hasError}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        className={className}
      />
      {hasError && <div style={{ textAlign: 'center', color: '#EE7402', fontSize: '12px' }}>{validationObject?.message}</div>}
    </div>
  );
}
